// extracted by mini-css-extract-plugin
export var questionBox = "_92-0";